export enum ContractTypeOptions {
  CURRENT_STANDARD_CONTRACT = '51e701e1-eb21-47af-bb3e-89b9c7097b8f',
  OLD_STANDARD_CONTRACT = '4db27aba-de47-4fb7-8e8c-e53f89c5bbef',
  SPECIAL_STANDARD_CONTRACT = '3af333af-4fb0-4c4e-a704-85f3d3ca9d69',
  CUSTOMER_SPECIAL_CONTRACT = 'e74b9090-367f-49a9-b107-191060a31557'
}
